var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2667 10.2833C31.6 12.6 33.9 16.2833 34.3667 20.5333",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81668 20.6167C6.25001 16.3834 8.51668 12.7 11.8167 10.3667",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 34.9C15.5833 35.8834 17.7833 36.4334 20.1 36.4334C22.3333 36.4334 24.4333 35.9334 26.3167 35.0167",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7524 9.28092C21.5933 9.28092 23.0857 7.78854 23.0857 5.94759C23.0857 4.10664 21.5933 2.61426 19.7524 2.61426C17.9114 2.61426 16.419 4.10664 16.419 5.94759C16.419 7.78854 17.9114 9.28092 19.7524 9.28092Z",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79763 32.5048C7.63858 32.5048 9.13096 31.0124 9.13096 29.1715C9.13096 27.3305 7.63858 25.8381 5.79763 25.8381C3.95668 25.8381 2.46429 27.3305 2.46429 29.1715C2.46429 31.0124 3.95668 32.5048 5.79763 32.5048Z",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5548 32.5048C34.3957 32.5048 35.8881 31.0124 35.8881 29.1715C35.8881 27.3305 34.3957 25.8381 32.5548 25.8381C30.7138 25.8381 29.2214 27.3305 29.2214 29.1715C29.2214 31.0124 30.7138 32.5048 32.5548 32.5048Z",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5675 22.96H17.885V28.36C17.885 29.62 18.5675 29.875 19.4 28.93L25.0775 22.48C25.775 21.6925 25.4825 21.04 24.425 21.04H22.1075V15.64C22.1075 14.38 21.425 14.125 20.5925 15.07L14.915 21.52C14.225 22.315 14.5175 22.96 15.5675 22.96Z",
    stroke: "#3C8DBC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b664844dcf0a7ae2c90a040127f0f05b.svg";
export { ForwardRef as ReactComponent };